import React, { useContext } from "react";
import { ThemeContext } from "../../../../constant/theme";
import { LanguageContext } from "../../../../constant/LanguageContext";
import { getCardStyle } from "../../styles/attendanceStyles";

const AttendanceHeader = ({ theme, isRTL, t, subtitle }) => {
  const { theme: contextTheme } = useContext(ThemeContext);
  const { language } = useContext(LanguageContext);
  const finalTheme = theme || contextTheme;

  const computeSubtitle = () => {
    if (subtitle) {
      if (typeof subtitle === "object") return subtitle[language] || subtitle.en || Object.values(subtitle)[0];
      return String(subtitle || "").trim();
    }
    return t?.attendanceSubtitle || "Monitor and manage employee attendance";
  };

  const displaySubtitle = computeSubtitle();

  return (
    <>
      <style>{`
        @keyframes slideInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      <div
        style={{
          background: finalTheme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
          padding: "32px",
          borderRadius: "24px",
          border: finalTheme === "dark" ? "1px solid rgba(255,255,255,0.15)" : "1px solid rgba(0,0,0,0.05)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          boxShadow: finalTheme === "dark"
            ? "0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1)"
            : "0 8px 32px rgba(0,0,0,0.1)",
          animation: "slideInDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)",
          transition: "all 0.3s ease",
          marginBottom: "72px",
          marginTop: "-36px",
          direction: isRTL ? "rtl" : "ltr",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <div>
            <h2
              style={{
                fontSize: "28px",
                fontWeight: "700",
                margin: 0,
                color: finalTheme === "dark" ? "#f1f5f9" : "#1e293b",
                letterSpacing: "-0.5px",
              }}
            >
              {t.attendanceManagement}
            </h2>
            {displaySubtitle && (
              <p
                style={{
                  margin: "12px 0 0 0",
                  fontSize: "15px",
                  fontWeight: 500,
                  color: finalTheme === "dark" ? "#cbd5e1" : "#64748b",
                }}
              >
                {displaySubtitle}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceHeader;